import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 101 101" fill="none" {...props}>
      <title>{props.title || 'Support'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88.25 45.25L25.75 88.25V69.5H13.25C9.79822 69.5 7 66.7018 7 63.25V13.25C7 9.79822 9.79822 7 13.25 7H82C85.4518 7 88.25 9.79822 88.25 13.25V45.25Z"
          fill="#BEEBF6"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M101 81.5H88.5V100.25L69.75 81.5H51V44H101V81.5Z"
          fill="#BEEBF6"
        />
        <path
          d="M34.375 75L21.875 84.375V65.625H9.375C5.92322 65.625 3.125 62.8268 3.125 59.375V9.375C3.125 5.92322 5.92322 3.125 9.375 3.125H78.125C81.5768 3.125 84.375 5.92322 84.375 9.375V28.125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.9709 44.584C28.911 46.6691 33.1306 48.1763 37.5001 49.059"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.125 21.875V28.125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.375 21.875V28.125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M96.875 78.125H84.375V96.875L65.625 78.125H46.875V40.625H96.875V78.125Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.375 57.8125C58.5121 57.8125 57.8125 58.5121 57.8125 59.375C57.8125 60.2379 58.5121 60.9375 59.375 60.9375C60.2379 60.9375 60.9375 60.2379 60.9375 59.375C60.9375 58.5121 60.2379 57.8125 59.375 57.8125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M71.875 57.8125C71.0121 57.8125 70.3125 58.5121 70.3125 59.375C70.3125 60.2379 71.0121 60.9375 71.875 60.9375C72.7379 60.9375 73.4375 60.2379 73.4375 59.375C73.4375 58.5121 72.7379 57.8125 71.875 57.8125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.375 57.8125C83.5121 57.8125 82.8125 58.5121 82.8125 59.375C82.8125 60.2379 83.5121 60.9375 84.375 60.9375C85.2379 60.9375 85.9375 60.2379 85.9375 59.375C85.9375 58.5121 85.2379 57.8125 84.375 57.8125"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
